/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  ETransportCustomerSubscriptionDto,
  ETransportCustomerSubscriptionRequestDto,
  ETransportFreightPlutoDto,
  ETransportSubscriptionAvailabilityDto,
  GetAdminFreightsParams,
  GetAdminTargetsParams,
  GetFreightsParams,
  GetSubscriptionAvailabilityParams,
  GetSubscriptionsParams,
  MinimalTarget,
  PlutoCustomerResponseDto,
  PlutoFreightResponseDto
} from '../../model';





/**
 * @summary Insert a freight
 */
export const addFreight = (
    eTransportFreightPlutoDto: ETransportFreightPlutoDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/v1.1/etransport/freight`,
      eTransportFreightPlutoDto,options
    );
  }



export const getAddFreightMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFreight>>, TError,{data: ETransportFreightPlutoDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addFreight>>, TError,{data: ETransportFreightPlutoDto}, TContext> => {

const mutationKey = ['addFreight'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addFreight>>, {data: ETransportFreightPlutoDto}> = (props) => {
          const {data} = props ?? {};

          return  addFreight(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddFreightMutationResult = NonNullable<Awaited<ReturnType<typeof addFreight>>>
    export type AddFreightMutationBody = ETransportFreightPlutoDto
    export type AddFreightMutationError = AxiosError<unknown>

    /**
 * @summary Insert a freight
 */
export const useAddFreight = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFreight>>, TError,{data: ETransportFreightPlutoDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addFreight>>,
        TError,
        {data: ETransportFreightPlutoDto},
        TContext
      > => {

      const mutationOptions = getAddFreightMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Mark a freight as deleted
 */
export const markFreightDeleted = (
    eTransportFreightPlutoDto: ETransportFreightPlutoDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/v1.1/etransport/freight`,{data:
      eTransportFreightPlutoDto, ...options}
    );
  }



export const getMarkFreightDeletedMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markFreightDeleted>>, TError,{data: ETransportFreightPlutoDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof markFreightDeleted>>, TError,{data: ETransportFreightPlutoDto}, TContext> => {

const mutationKey = ['markFreightDeleted'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markFreightDeleted>>, {data: ETransportFreightPlutoDto}> = (props) => {
          const {data} = props ?? {};

          return  markFreightDeleted(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkFreightDeletedMutationResult = NonNullable<Awaited<ReturnType<typeof markFreightDeleted>>>
    export type MarkFreightDeletedMutationBody = ETransportFreightPlutoDto
    export type MarkFreightDeletedMutationError = AxiosError<unknown>

    /**
 * @summary Mark a freight as deleted
 */
export const useMarkFreightDeleted = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markFreightDeleted>>, TError,{data: ETransportFreightPlutoDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markFreightDeleted>>,
        TError,
        {data: ETransportFreightPlutoDto},
        TContext
      > => {

      const mutationOptions = getMarkFreightDeletedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update a freight
 */
export const updateFreight = (
    eTransportFreightPlutoDto: ETransportFreightPlutoDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.patch(
      `/api/v1.1/etransport/freight`,
      eTransportFreightPlutoDto,options
    );
  }



export const getUpdateFreightMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFreight>>, TError,{data: ETransportFreightPlutoDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateFreight>>, TError,{data: ETransportFreightPlutoDto}, TContext> => {

const mutationKey = ['updateFreight'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFreight>>, {data: ETransportFreightPlutoDto}> = (props) => {
          const {data} = props ?? {};

          return  updateFreight(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFreightMutationResult = NonNullable<Awaited<ReturnType<typeof updateFreight>>>
    export type UpdateFreightMutationBody = ETransportFreightPlutoDto
    export type UpdateFreightMutationError = AxiosError<unknown>

    /**
 * @summary Update a freight
 */
export const useUpdateFreight = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFreight>>, TError,{data: ETransportFreightPlutoDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFreight>>,
        TError,
        {data: ETransportFreightPlutoDto},
        TContext
      > => {

      const mutationOptions = getUpdateFreightMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get all E-Transport targets in JSON
 */
export const getTargets1 = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MinimalTarget[]>> => {
    
    
    return axios.default.get(
      `/api/v1.1/etransport/targets`,options
    );
  }




export const getGetTargets1QueryKey = () => {
    return [
    `/api/v1.1/etransport/targets`
    ] as const;
    }

    
export const getGetTargets1QueryOptions = <TData = Awaited<ReturnType<typeof getTargets1>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargets1>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargets1QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargets1>>> = ({ signal }) => getTargets1({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTargets1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTargets1QueryResult = NonNullable<Awaited<ReturnType<typeof getTargets1>>>
export type GetTargets1QueryError = AxiosError<unknown>


export function useGetTargets1<TData = Awaited<ReturnType<typeof getTargets1>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargets1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargets1>>,
          TError,
          Awaited<ReturnType<typeof getTargets1>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargets1<TData = Awaited<ReturnType<typeof getTargets1>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargets1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTargets1>>,
          TError,
          Awaited<ReturnType<typeof getTargets1>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargets1<TData = Awaited<ReturnType<typeof getTargets1>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargets1>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all E-Transport targets in JSON
 */

export function useGetTargets1<TData = Awaited<ReturnType<typeof getTargets1>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTargets1>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTargets1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetTargets1SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTargets1>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets1>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTargets1QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTargets1>>> = ({ signal }) => getTargets1({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTargets1SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTargets1>>>
export type GetTargets1SuspenseQueryError = AxiosError<unknown>


export function useGetTargets1Suspense<TData = Awaited<ReturnType<typeof getTargets1>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets1>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargets1Suspense<TData = Awaited<ReturnType<typeof getTargets1>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets1>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTargets1Suspense<TData = Awaited<ReturnType<typeof getTargets1>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets1>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all E-Transport targets in JSON
 */

export function useGetTargets1Suspense<TData = Awaited<ReturnType<typeof getTargets1>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTargets1>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTargets1SuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get all E-Transport freight in JSON
 */
export const getFreights = (
    params?: GetFreightsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlutoFreightResponseDto>> => {
    
    
    return axios.default.get(
      `/api/v1.1/etransport/freights`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetFreightsQueryKey = (params?: GetFreightsParams,) => {
    return [
    `/api/v1.1/etransport/freights`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetFreightsQueryOptions = <TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(params?: GetFreightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFreightsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFreights>>> = ({ signal }) => getFreights(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFreightsQueryResult = NonNullable<Awaited<ReturnType<typeof getFreights>>>
export type GetFreightsQueryError = AxiosError<unknown>


export function useGetFreights<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params: undefined |  GetFreightsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFreights>>,
          TError,
          Awaited<ReturnType<typeof getFreights>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFreights<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params?: GetFreightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFreights>>,
          TError,
          Awaited<ReturnType<typeof getFreights>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFreights<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params?: GetFreightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all E-Transport freight in JSON
 */

export function useGetFreights<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params?: GetFreightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFreightsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFreightsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(params?: GetFreightsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFreightsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFreights>>> = ({ signal }) => getFreights(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFreightsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFreights>>>
export type GetFreightsSuspenseQueryError = AxiosError<unknown>


export function useGetFreightsSuspense<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params: undefined |  GetFreightsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFreightsSuspense<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params?: GetFreightsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFreightsSuspense<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params?: GetFreightsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all E-Transport freight in JSON
 */

export function useGetFreightsSuspense<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params?: GetFreightsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFreightsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get all admin E-Transport targets in JSON
 */
export const getAdminTargets = (
    params: GetAdminTargetsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MinimalTarget[]>> => {
    
    
    return axios.default.get(
      `/api/v1.1/etransport/admin/targets`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAdminTargetsQueryKey = (params?: GetAdminTargetsParams,) => {
    return [
    `/api/v1.1/etransport/admin/targets`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminTargetsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminTargets>>, TError = AxiosError<unknown>>(params: GetAdminTargetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminTargetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminTargets>>> = ({ signal }) => getAdminTargets(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminTargets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminTargetsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminTargets>>>
export type GetAdminTargetsQueryError = AxiosError<unknown>


export function useGetAdminTargets<TData = Awaited<ReturnType<typeof getAdminTargets>>, TError = AxiosError<unknown>>(
 params: GetAdminTargetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTargets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTargets>>,
          TError,
          Awaited<ReturnType<typeof getAdminTargets>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminTargets<TData = Awaited<ReturnType<typeof getAdminTargets>>, TError = AxiosError<unknown>>(
 params: GetAdminTargetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTargets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTargets>>,
          TError,
          Awaited<ReturnType<typeof getAdminTargets>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminTargets<TData = Awaited<ReturnType<typeof getAdminTargets>>, TError = AxiosError<unknown>>(
 params: GetAdminTargetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all admin E-Transport targets in JSON
 */

export function useGetAdminTargets<TData = Awaited<ReturnType<typeof getAdminTargets>>, TError = AxiosError<unknown>>(
 params: GetAdminTargetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminTargetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAdminTargetsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAdminTargets>>, TError = AxiosError<unknown>>(params: GetAdminTargetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminTargetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminTargets>>> = ({ signal }) => getAdminTargets(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminTargets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminTargetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminTargets>>>
export type GetAdminTargetsSuspenseQueryError = AxiosError<unknown>


export function useGetAdminTargetsSuspense<TData = Awaited<ReturnType<typeof getAdminTargets>>, TError = AxiosError<unknown>>(
 params: GetAdminTargetsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminTargetsSuspense<TData = Awaited<ReturnType<typeof getAdminTargets>>, TError = AxiosError<unknown>>(
 params: GetAdminTargetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminTargetsSuspense<TData = Awaited<ReturnType<typeof getAdminTargets>>, TError = AxiosError<unknown>>(
 params: GetAdminTargetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all admin E-Transport targets in JSON
 */

export function useGetAdminTargetsSuspense<TData = Awaited<ReturnType<typeof getAdminTargets>>, TError = AxiosError<unknown>>(
 params: GetAdminTargetsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminTargets>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminTargetsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get all admin E-Transport freights in JSON
 */
export const getAdminFreights = (
    params: GetAdminFreightsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlutoFreightResponseDto>> => {
    
    
    return axios.default.get(
      `/api/v1.1/etransport/admin/freights`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetAdminFreightsQueryKey = (params?: GetAdminFreightsParams,) => {
    return [
    `/api/v1.1/etransport/admin/freights`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminFreightsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFreights>>, TError = AxiosError<unknown>>(params: GetAdminFreightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFreightsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFreights>>> = ({ signal }) => getAdminFreights(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFreights>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminFreightsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFreights>>>
export type GetAdminFreightsQueryError = AxiosError<unknown>


export function useGetAdminFreights<TData = Awaited<ReturnType<typeof getAdminFreights>>, TError = AxiosError<unknown>>(
 params: GetAdminFreightsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFreights>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFreights>>,
          TError,
          Awaited<ReturnType<typeof getAdminFreights>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFreights<TData = Awaited<ReturnType<typeof getAdminFreights>>, TError = AxiosError<unknown>>(
 params: GetAdminFreightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFreights>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFreights>>,
          TError,
          Awaited<ReturnType<typeof getAdminFreights>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFreights<TData = Awaited<ReturnType<typeof getAdminFreights>>, TError = AxiosError<unknown>>(
 params: GetAdminFreightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all admin E-Transport freights in JSON
 */

export function useGetAdminFreights<TData = Awaited<ReturnType<typeof getAdminFreights>>, TError = AxiosError<unknown>>(
 params: GetAdminFreightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminFreightsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAdminFreightsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFreights>>, TError = AxiosError<unknown>>(params: GetAdminFreightsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFreightsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFreights>>> = ({ signal }) => getAdminFreights(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminFreights>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminFreightsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFreights>>>
export type GetAdminFreightsSuspenseQueryError = AxiosError<unknown>


export function useGetAdminFreightsSuspense<TData = Awaited<ReturnType<typeof getAdminFreights>>, TError = AxiosError<unknown>>(
 params: GetAdminFreightsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFreightsSuspense<TData = Awaited<ReturnType<typeof getAdminFreights>>, TError = AxiosError<unknown>>(
 params: GetAdminFreightsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFreightsSuspense<TData = Awaited<ReturnType<typeof getAdminFreights>>, TError = AxiosError<unknown>>(
 params: GetAdminFreightsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all admin E-Transport freights in JSON
 */

export function useGetAdminFreightsSuspense<TData = Awaited<ReturnType<typeof getAdminFreights>>, TError = AxiosError<unknown>>(
 params: GetAdminFreightsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminFreightsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get all E-Transport customers in JSON
 */
export const getETransportCustomers = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PlutoCustomerResponseDto>> => {
    
    
    return axios.default.get(
      `/api/v1.1/etransport/admin/customers`,options
    );
  }




export const getGetETransportCustomersQueryKey = () => {
    return [
    `/api/v1.1/etransport/admin/customers`
    ] as const;
    }

    
export const getGetETransportCustomersQueryOptions = <TData = Awaited<ReturnType<typeof getETransportCustomers>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETransportCustomers>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetETransportCustomersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getETransportCustomers>>> = ({ signal }) => getETransportCustomers({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getETransportCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetETransportCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof getETransportCustomers>>>
export type GetETransportCustomersQueryError = AxiosError<unknown>


export function useGetETransportCustomers<TData = Awaited<ReturnType<typeof getETransportCustomers>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETransportCustomers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getETransportCustomers>>,
          TError,
          Awaited<ReturnType<typeof getETransportCustomers>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetETransportCustomers<TData = Awaited<ReturnType<typeof getETransportCustomers>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETransportCustomers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getETransportCustomers>>,
          TError,
          Awaited<ReturnType<typeof getETransportCustomers>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetETransportCustomers<TData = Awaited<ReturnType<typeof getETransportCustomers>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETransportCustomers>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all E-Transport customers in JSON
 */

export function useGetETransportCustomers<TData = Awaited<ReturnType<typeof getETransportCustomers>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETransportCustomers>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetETransportCustomersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetETransportCustomersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getETransportCustomers>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getETransportCustomers>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetETransportCustomersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getETransportCustomers>>> = ({ signal }) => getETransportCustomers({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getETransportCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetETransportCustomersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getETransportCustomers>>>
export type GetETransportCustomersSuspenseQueryError = AxiosError<unknown>


export function useGetETransportCustomersSuspense<TData = Awaited<ReturnType<typeof getETransportCustomers>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getETransportCustomers>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetETransportCustomersSuspense<TData = Awaited<ReturnType<typeof getETransportCustomers>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getETransportCustomers>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetETransportCustomersSuspense<TData = Awaited<ReturnType<typeof getETransportCustomers>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getETransportCustomers>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all E-Transport customers in JSON
 */

export function useGetETransportCustomersSuspense<TData = Awaited<ReturnType<typeof getETransportCustomers>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getETransportCustomers>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetETransportCustomersSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get E-Transport subscriptions for a customer
 */
export const getSubscriptions = (
    params: GetSubscriptionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ETransportCustomerSubscriptionDto[]>> => {
    
    
    return axios.default.get(
      `/api/v1.1/etransport/subscriptions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetSubscriptionsQueryKey = (params?: GetSubscriptionsParams,) => {
    return [
    `/api/v1.1/etransport/subscriptions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = AxiosError<unknown>>(params: GetSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptions>>> = ({ signal }) => getSubscriptions(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptions>>>
export type GetSubscriptionsQueryError = AxiosError<unknown>


export function useGetSubscriptions<TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptions>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptions<TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptions>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptions<TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get E-Transport subscriptions for a customer
 */

export function useGetSubscriptions<TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubscriptionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetSubscriptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = AxiosError<unknown>>(params: GetSubscriptionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptions>>> = ({ signal }) => getSubscriptions(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubscriptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptions>>>
export type GetSubscriptionsSuspenseQueryError = AxiosError<unknown>


export function useGetSubscriptionsSuspense<TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionsSuspense<TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionsSuspense<TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get E-Transport subscriptions for a customer
 */

export function useGetSubscriptionsSuspense<TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubscriptionsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Subscribe a customer to a registered VAT
 */
export const subscribe = (
    eTransportCustomerSubscriptionRequestDto: ETransportCustomerSubscriptionRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ETransportCustomerSubscriptionDto>> => {
    
    
    return axios.default.post(
      `/api/v1.1/etransport/subscription`,
      eTransportCustomerSubscriptionRequestDto,options
    );
  }



export const getSubscribeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribe>>, TError,{data: ETransportCustomerSubscriptionRequestDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof subscribe>>, TError,{data: ETransportCustomerSubscriptionRequestDto}, TContext> => {

const mutationKey = ['subscribe'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof subscribe>>, {data: ETransportCustomerSubscriptionRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  subscribe(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubscribeMutationResult = NonNullable<Awaited<ReturnType<typeof subscribe>>>
    export type SubscribeMutationBody = ETransportCustomerSubscriptionRequestDto
    export type SubscribeMutationError = AxiosError<unknown>

    /**
 * @summary Subscribe a customer to a registered VAT
 */
export const useSubscribe = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribe>>, TError,{data: ETransportCustomerSubscriptionRequestDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof subscribe>>,
        TError,
        {data: ETransportCustomerSubscriptionRequestDto},
        TContext
      > => {

      const mutationOptions = getSubscribeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Revoke a customer VAT subscription
 */
export const revoke = (
    eTransportCustomerSubscriptionRequestDto: ETransportCustomerSubscriptionRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ETransportCustomerSubscriptionDto>> => {
    
    
    return axios.default.post(
      `/api/v1.1/etransport/subscription/revoke`,
      eTransportCustomerSubscriptionRequestDto,options
    );
  }



export const getRevokeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revoke>>, TError,{data: ETransportCustomerSubscriptionRequestDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof revoke>>, TError,{data: ETransportCustomerSubscriptionRequestDto}, TContext> => {

const mutationKey = ['revoke'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revoke>>, {data: ETransportCustomerSubscriptionRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  revoke(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RevokeMutationResult = NonNullable<Awaited<ReturnType<typeof revoke>>>
    export type RevokeMutationBody = ETransportCustomerSubscriptionRequestDto
    export type RevokeMutationError = AxiosError<unknown>

    /**
 * @summary Revoke a customer VAT subscription
 */
export const useRevoke = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revoke>>, TError,{data: ETransportCustomerSubscriptionRequestDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revoke>>,
        TError,
        {data: ETransportCustomerSubscriptionRequestDto},
        TContext
      > => {

      const mutationOptions = getRevokeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Subscribe a customer to a registered VAT as super-admin
 */
export const adminSubscribe = (
    eTransportCustomerSubscriptionRequestDto: ETransportCustomerSubscriptionRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ETransportCustomerSubscriptionDto>> => {
    
    
    return axios.default.post(
      `/api/v1.1/etransport/admin/subscription`,
      eTransportCustomerSubscriptionRequestDto,options
    );
  }



export const getAdminSubscribeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSubscribe>>, TError,{data: ETransportCustomerSubscriptionRequestDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof adminSubscribe>>, TError,{data: ETransportCustomerSubscriptionRequestDto}, TContext> => {

const mutationKey = ['adminSubscribe'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSubscribe>>, {data: ETransportCustomerSubscriptionRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  adminSubscribe(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminSubscribeMutationResult = NonNullable<Awaited<ReturnType<typeof adminSubscribe>>>
    export type AdminSubscribeMutationBody = ETransportCustomerSubscriptionRequestDto
    export type AdminSubscribeMutationError = AxiosError<unknown>

    /**
 * @summary Subscribe a customer to a registered VAT as super-admin
 */
export const useAdminSubscribe = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSubscribe>>, TError,{data: ETransportCustomerSubscriptionRequestDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminSubscribe>>,
        TError,
        {data: ETransportCustomerSubscriptionRequestDto},
        TContext
      > => {

      const mutationOptions = getAdminSubscribeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Revoke a customer VAT subscription as super-admin
 */
export const adminRevoke = (
    eTransportCustomerSubscriptionRequestDto: ETransportCustomerSubscriptionRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ETransportCustomerSubscriptionDto>> => {
    
    
    return axios.default.post(
      `/api/v1.1/etransport/admin/subscription/revoke`,
      eTransportCustomerSubscriptionRequestDto,options
    );
  }



export const getAdminRevokeMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRevoke>>, TError,{data: ETransportCustomerSubscriptionRequestDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof adminRevoke>>, TError,{data: ETransportCustomerSubscriptionRequestDto}, TContext> => {

const mutationKey = ['adminRevoke'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRevoke>>, {data: ETransportCustomerSubscriptionRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  adminRevoke(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminRevokeMutationResult = NonNullable<Awaited<ReturnType<typeof adminRevoke>>>
    export type AdminRevokeMutationBody = ETransportCustomerSubscriptionRequestDto
    export type AdminRevokeMutationError = AxiosError<unknown>

    /**
 * @summary Revoke a customer VAT subscription as super-admin
 */
export const useAdminRevoke = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRevoke>>, TError,{data: ETransportCustomerSubscriptionRequestDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminRevoke>>,
        TError,
        {data: ETransportCustomerSubscriptionRequestDto},
        TContext
      > => {

      const mutationOptions = getAdminRevokeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Reassign the responsible customer for an active VAT token
 */
export const reassignResponsibleCustomer = (
    eTransportCustomerSubscriptionRequestDto: ETransportCustomerSubscriptionRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/v1.1/etransport/admin/subscription/responsible-customer`,
      eTransportCustomerSubscriptionRequestDto,options
    );
  }



export const getReassignResponsibleCustomerMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reassignResponsibleCustomer>>, TError,{data: ETransportCustomerSubscriptionRequestDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof reassignResponsibleCustomer>>, TError,{data: ETransportCustomerSubscriptionRequestDto}, TContext> => {

const mutationKey = ['reassignResponsibleCustomer'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reassignResponsibleCustomer>>, {data: ETransportCustomerSubscriptionRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  reassignResponsibleCustomer(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReassignResponsibleCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof reassignResponsibleCustomer>>>
    export type ReassignResponsibleCustomerMutationBody = ETransportCustomerSubscriptionRequestDto
    export type ReassignResponsibleCustomerMutationError = AxiosError<unknown>

    /**
 * @summary Reassign the responsible customer for an active VAT token
 */
export const useReassignResponsibleCustomer = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reassignResponsibleCustomer>>, TError,{data: ETransportCustomerSubscriptionRequestDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reassignResponsibleCustomer>>,
        TError,
        {data: ETransportCustomerSubscriptionRequestDto},
        TContext
      > => {

      const mutationOptions = getReassignResponsibleCustomerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Check whether a VAT is available for customer subscription
 */
export const getSubscriptionAvailability = (
    params: GetSubscriptionAvailabilityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ETransportSubscriptionAvailabilityDto>> => {
    
    
    return axios.default.get(
      `/api/v1.1/etransport/subscription/availability`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetSubscriptionAvailabilityQueryKey = (params?: GetSubscriptionAvailabilityParams,) => {
    return [
    `/api/v1.1/etransport/subscription/availability`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSubscriptionAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError = AxiosError<unknown>>(params: GetSubscriptionAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionAvailabilityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionAvailability>>> = ({ signal }) => getSubscriptionAvailability(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubscriptionAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionAvailability>>>
export type GetSubscriptionAvailabilityQueryError = AxiosError<unknown>


export function useGetSubscriptionAvailability<TData = Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionAvailabilityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionAvailability>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionAvailability>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionAvailability<TData = Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionAvailability>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionAvailability>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionAvailability<TData = Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check whether a VAT is available for customer subscription
 */

export function useGetSubscriptionAvailability<TData = Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubscriptionAvailabilityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetSubscriptionAvailabilitySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError = AxiosError<unknown>>(params: GetSubscriptionAvailabilityParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionAvailabilityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionAvailability>>> = ({ signal }) => getSubscriptionAvailability(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubscriptionAvailabilitySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionAvailability>>>
export type GetSubscriptionAvailabilitySuspenseQueryError = AxiosError<unknown>


export function useGetSubscriptionAvailabilitySuspense<TData = Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionAvailabilityParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionAvailabilitySuspense<TData = Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionAvailabilityParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionAvailabilitySuspense<TData = Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionAvailabilityParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check whether a VAT is available for customer subscription
 */

export function useGetSubscriptionAvailabilitySuspense<TData = Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError = AxiosError<unknown>>(
 params: GetSubscriptionAvailabilityParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionAvailability>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubscriptionAvailabilitySuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




